<div
  id="left-sidebar"
  class="sidebar"
  *ngIf="sidebarVisible"
>
  <div class="sidebar-scroll sidebar-scroll-area" role="navigation" aria-label="Sidebar">
    <div class="user-account">
      <img
        [src]="profileUrl ? profileUrl : 'assets/images/profile-default.svg'"
        class="rounded-circle user-photo"
        alt="User Profile Picture"
      />
      <div class="dropdown" ngbDropdown>
        <span>Welcome,</span>
        <a
          href="javascript:void(0);"
          class="dropdown-toggle user-name"
          ngbDropdownToggle
          ><strong> {{ fullName }} </strong><br />( {{ user?.email }} )</a
        >
        <ul class="dropdown-menu dropdown-menu-right account" ngbDropdownMenu>
          <li>
            <a [routerLink]="['/members/my-profile']"
              ><i class="fa fa-user"></i>My Profile</a
            >
          </li>
          <li>
            <a [routerLink]="['/membership-card']"
              ><i class="fa fa-id-card"></i>Digital Membership Card</a
            >
          </li>
          <li>
            <a [routerLink]="['/members/my-security']"
              ><i class="icon-lock"></i>Security</a
            >
          </li>

          <li class="divider"></li>
          <li>
            <a [routerLink]="['/authentication/logout']"
              ><i class="icon-power"></i>Logout</a
            >
          </li>
        </ul>
      </div>
      <!-- <hr /> -->
      <!-- <ul class="row list-unstyled">
        <li class="col-4">
          <small>Sales</small>
          <h6>456</h6>
        </li>
        <li class="col-4">
          <small>Order</small>
          <h6>1350</h6>
        </li>
        <li class="col-4">
          <small>Revenue</small>
          <h6>$2.13B</h6>
        </li>
      </ul> -->
    </div>
    <!-- Nav tabs -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{ active: navTab == 'menu' }"
          (click)="changeNavTab('menu')"
          role="button"
          tabindex="0"
          (keydown)="onNavTabKeydown($event, 'menu')"
          >Menu</a
        >
      </li>
      <li
        class="nav-item"
        menuPermission
        [allowedPermissions]="[
          'report.viewTreasurer',
          'report.viewByCategory',
          'report.viewAccount',
          'report.viewBudgetItem'
        ]"
      >
        <a
          class="nav-link"
          [ngClass]="{ active: navTab == 'reports' }"
          (click)="changeNavTab('reports')"
          role="button"
          tabindex="0"
          (keydown)="onNavTabKeydown($event, 'reports')"
        >
          <!-- <i class="icon-graph"></i>  -->
          Reports</a
        >
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{ active: navTab == 'setting' }"
          (click)="changeNavTab('setting')"
          role="button"
          tabindex="0"
          (keydown)="onNavTabKeydown($event, 'setting')"
          ><i class="icon-settings"></i
        ></a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          [ngClass]="{ active: navTab == 'question' }"
          (click)="changeNavTab('question')"
          role="button"
          tabindex="0"
          (keydown)="onNavTabKeydown($event, 'question')"
          ><i class="icon-question"></i
        ></a>
      </li>
    </ul>

    <!-- Tab panes -->
    <div class="tab-content p-l-0 p-r-0">
      <div
        class="tab-pane"
        id="menu"
        [ngClass]="{ active: navTab == 'menu' || !navTab }"
      >
        <!-- Begin Original Menu -->
        <!-- End original menu  -->
        <nav id="left-sidebar-nav" class="sidebar-nav">
          <ul id="main-menu" class="metismenu">
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [ngClass]="{ active: currentActiveMenu == 'dashboard' }"
            >
              <a
                (click)="activeInactiveMenu('dashboard')"
                [routerLink]="['/transactions/index']"
                ><i class="fas fa-exchange"></i> <span>My Transactions</span></a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [ngClass]="{ active: currentActiveMenu == 'my-tickets' }"
            >
              <a
                (click)="activeInactiveMenu('my-tickets')"
                [routerLink]="['/transactions/my-tickets']"
                ><i class="fa fa-ticket"></i> <span>My Tickets</span></a
              >
            </li>
            <!-- <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              [ngClass]="{ active: currentActiveMenu == 'my-items' }"
            >
              <a
                (click)="activeInactiveMenu('my-items')"
                [routerLink]="['/transactions/my-items']"
                ><i class="fa fa-tag"></i> <span>My Items</span></a
              >
            </li> -->
            <li
              [ngClass]="{ active: currentActiveMenu == 'transactions' }"
              [allowedPermissions]="[
                'transaction.viewApproval',
                'transaction.completeTransaction',
                'transaction.viewHistory',
                'transaction.addInvoice'
              ]"
              menuPermission
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('transactions')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'transactions'" (keydown)="onMenuToggleKeydown($event, 'transactions')"
                ><i class="fa fa-credit-card"></i> <span>Transactions</span></a
              >
              <ul *ngIf="currentActiveMenu == 'transactions'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'approvals' }"
                  menuPermission
                  requiredPermission="transaction.viewApproval"
                >
                  <a [routerLink]="['/transactions/approvals']"
                    ><i class="fa fa-thumbs-o-up"></i> <span>Approvals</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu === 'funds-request-approvers' }"
                  menuPermission
                  requiredPermission="organization.manageFundsRequestTypes"
                >
                  <a
                    (click)="activeInactiveMenu('funds-request-approvers')"
                    [routerLink]="['/organization/funds-request-approvers']"
                    ><i class="fa fa-user-plus"></i> <span>Approver Configuration</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'complete' }"
                  menuPermission
                  requiredPermission="transaction.completeTransaction"
                >
                  <a [routerLink]="['/transactions/complete']"
                    ><i class="fa fa-check"></i>
                    <span>Complete Transactions</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'history' }"
                  menuPermission
                  requiredPermission="transaction.addFinanceInformation"
                >
                  <a [routerLink]="['/transactions/history']"
                    ><i class="fa fa-history"></i>
                    <span>Transaction History</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'history' }"
                  menuPermission
                  requiredPermission="transaction.addFinanceInformation"
                >
                  <a [routerLink]="['/transactions/unassigned']"
                    ><i class="fa fa-history"></i>
                    <span>Unassigned Transactions</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'invoices' }"
                  menuPermission
                  requiredPermission="transaction.addInvoice"
                >
                  <a [routerLink]="['/transactions', 'invoices']"
                    ><i class="fa fa-calculator"></i> <span>Invoices</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'import' }"
                  menuPermission
                  requiredPermission="transaction.addInvoice"
                >
                  <a [routerLink]="['/transactions', 'import']"
                    ><i class="fa fa-upload"></i>
                    <span>Import Transactions</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'payouts' }"
                  menuPermission
                  [allowedPermissions]="[
                    'transaction.viewApproval',
                    'transaction.completeTransaction',
                    'transaction.viewHistory',
                    'transaction.addInvoice'
                  ]"
                >
                  <a [routerLink]="['/transactions', 'deposits']"
                    ><i class="fas fa-money"></i>
                    <span>duesPlus Deposits</span></a
                  >
                </li>
              </ul>
            </li>
            <li
              [ngClass]="{ active: currentActiveMenu == 'campaigns' }"
              [allowedPermissions]="['campaign.view', 'ticket.view']"
              menuPermission
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('campaigns')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'campaigns'" (keydown)="onMenuToggleKeydown($event, 'campaigns')"
                ><i class="fa fa-shopping-cart"></i> <span>Campaigns</span></a
              >
              <ul *ngIf="currentActiveMenu == 'campaigns'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'salecampaigns' }"
                  menuPermission
                  requiredPermission="campaign.view"
                >
                  <a [routerLink]="['/sale', 'campaign', 'list']"
                    ><i class="fa fa-list"></i> <span>Campaign List</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'orders' }"
                  menuPermission
                  requiredPermission="campaign.viewOrders"
                >
                  <a [routerLink]="['/sale', 'campaign', 'orders']"
                    ><i class="fa fa-tags"></i>
                    <span>Campaign Transactions</span>
                    <span
                      *ngIf="unmatchedCount > 0"
                      style="background: #d97706; color: #fff; border-radius: 10px; padding: 1px 6px; font-size: 10px; margin-left: 6px; vertical-align: middle;"
                    >{{ unmatchedCount }}</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'tickets' }"
                  menuPermission
                  [allowedPermissions]="['ticket.view', 'ticket.scan']"
                >
                  <a
                    [routerLink]="['/sale', 'campaign', 'tickets']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><i class="fa fa-ticket"></i> <span>Event Tickets</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'products' }"
                  menuPermission
                  requiredPermission="campaign.addItem"
                >
                  <a [routerLink]="['/transactions', 'products']"
                    ><i class="fa fa-list-alt"></i> <span>Sale Items</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'scan-ticket' }"
                >
                  <a
                    [routerLink]="['/transactions/scan-ticket']"
                    menuPermission
                    requiredPermission="ticket.scan"
                    ><i class="fas fa-scanner"></i> <span>Scan Tickets</span></a
                  >
                </li>
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'approvals' }"
                  menuPermission
                  requiredPermission="transaction.viewApproval"
                >
                  <a [routerLink]="['/transactions/approvals']"
                    ><i class="fa fa-thumbs-o-up"></i> <span>Approvals</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu === 'funds-request-approvers' }"
                  menuPermission
                  requiredPermission="organization.manageFundsRequestTypes"
                >
                  <a
                    (click)="activeInactiveMenu('funds-request-approvers')"
                    [routerLink]="['/organization/funds-request-approvers']"
                    ><i class="fa fa-user-plus"></i> <span>Approver Configuration</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'complete' }"
                  menuPermission
                  requiredPermission="transaction.completeTransaction"
                >
                  <a [routerLink]="['/transactions/complete']"
                    ><i class="fa fa-check"></i>
                    <span>Complete Transactions</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'history' }"
                  menuPermission
                  requiredPermission="transaction.viewHistory"
                >
                  <a [routerLink]="['/transactions/history']"
                    ><i class="fa fa-history"></i>
                    <span>Transaction History</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'invoices' }"
                  menuPermission
                  requiredPermission="transaction.addInvoice"
                >
                  <a [routerLink]="['/transactions', 'invoices']"
                    ><i class="fa fa-calculator"></i> <span>Invoices</span></a
                  >
                </li> -->
              </ul>
            </li>
           
            <li
              *ngIf="showMessages"
              [ngClass]="{ active: currentActiveMenu == 'text-messages' }"
              [allowedPermissions]="['message.view']"
              menuPermission
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('text-messages')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'text-messages'" (keydown)="onMenuToggleKeydown($event, 'text-messages')"
                ><i class="fa fa-comment"></i> <span>Communications</span><span class="menu-badge menu-badge-new">NEW</span></a
              >
              <ul *ngIf="currentActiveMenu == 'text-messages'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'message-campaigns' }"
                  menuPermission
                  requiredPermission="message.view"
                >
                  <a [routerLink]="['/messages', 'campaigns']"
                    ><i class="fa fa-list"></i> <span>Message Campaigns</span></a
                  >
                </li>
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'textcampaigns' }"
                  menuPermission
                  requiredPermission="message.view"
                >
                  <a [routerLink]="['/messages']"
                    ><i class="fa fa-list"></i> <span>Messages</span></a
                  >
                </li> -->
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'orders' }"
                  menuPermission
                  requiredPermission="message.view"
                >
                  <a [routerLink]="['/messages', 'compose']"
                    ><i class="fas fa-pen"></i> <span>Compose</span></a
                  >
                <!-- </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'inbox' }"
                  menuPermission
                  requiredPermission="message.view"
                >
                  <a [routerLink]="['/messages', 'inbox']"
                    ><i class="fas fa-pen"></i> <span>Inbox</span></a
                  >
                </li> -->
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'tickets' }"
                  menuPermission
                  [allowedPermissions]="['ticket.view', 'ticket.scan']"
                >
                  <a
                    [routerLink]="['/sale', 'campaign', 'tickets']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><i class="fa fa-ticket"></i> <span>Event Tickets</span></a
                  >
                </li> -->
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'products' }"
                  menuPermission
                  requiredPermission="campaign.addItem"
                >
                  <a [routerLink]="['/transactions', 'products']"
                    ><i class="fa fa-list-alt"></i> <span>Sale Items</span></a
                  >
                </li> -->
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'scan-ticket' }"
                >
                  <a
                    [routerLink]="['/transactions/scan-ticket']"
                    menuPermission
                    requiredPermission="ticket.scan"
                    ><i class="fas fa-scanner"></i> <span>Scan Tickets</span></a
                  >
                </li> -->
              </ul>
            </li>

            <li
              [ngClass]="{ active: currentActiveMenu == 'meetings' }"
               menuPermission
               requiredPermission="meeting.view"
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('meetings')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'meetings'" (keydown)="onMenuToggleKeydown($event, 'meetings')"
                ><i class="fa fa-calendar"></i> <span>Meetings</span></a
              >
              <ul *ngIf="currentActiveMenu == 'meetings'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="meeting.view"
                >
                  <a [routerLink]="['/meetings']"
                    ><i class="fa fa-list"></i> <span>Meeting List</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                   menuPermission
               requiredPermission="meeting.report"
                >
                  <a [routerLink]="['/meetings', 'reports']"
                    ><i class="fa fa-chart-bar"></i> <span>Attendance Reports</span></a
                  >
                </li>
              </ul>
            </li>

            <!-- NAA Budget Tools -->
            <li *ngIf="showBudgetTools"
              [ngClass]="{ active: currentActiveMenu == 'naa-budget' }"
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('naa-budget')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'naa-budget'" (keydown)="onMenuToggleKeydown($event, 'naa-budget')"
                ><i class="fa fa-calculator"></i> <span>FAMU NAA Finance Tool</span></a
              >
              <ul *ngIf="currentActiveMenu == 'naa-budget'">
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'dashboard']"><i class="fa fa-home"></i> <span>Dashboard</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'imports']"><i class="fa fa-upload"></i> <span>Imports</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'review']"><i class="fa fa-check-square"></i> <span>Review &amp; Reconcile</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'rules']"><i class="fa fa-book"></i> <span>Rules Library</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'reports']"><i class="fa fa-bar-chart"></i> <span>Reports</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'dues', 'reports', 'chapter']"><i class="fa fa-sitemap"></i> <span>Chapter Report</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'dues', 'reports', 'region']"><i class="fa fa-map-marker"></i> <span>Region Report</span></a>
                </li>
              </ul>
            </li>

            <li
              [ngClass]="{ active: currentActiveMenu == 'finance' }"
              [allowedPermissions]="[
                'transaction.viewAccount',
                'organization.editBudgetCategory'
              ]"
              menuPermission
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('finance')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'finance'" (keydown)="onMenuToggleKeydown($event, 'finance')"
                ><i class="fa fa-bank"></i> <span>Finance</span></a
              >
              <ul *ngIf="currentActiveMenu == 'finance'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="transaction.viewAccount"
                >
                  <a [routerLink]="['/accounts/list']">
                    <i class="fas fa-sack-dollar"></i>
                    <span>Funding Accounts</span>
                  </a>
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="transaction.viewAccount"
                >
                  <a [routerLink]="['/accounts/expense-match']">
                    <i class="fa fa-link"></i>
                    <span>Expense Match Review</span>
                    <span
                      *ngIf="expenseMatchPendingCount > 0"
                      style="background: #d97706; color: #fff; border-radius: 10px; padding: 1px 6px; font-size: 10px; margin-left: 6px; vertical-align: middle;"
                    >{{ expenseMatchPendingCount }}</span>
                  </a>
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="organization.editBudgetCategory"
                >
                  <a
                    [routerLink]="['/organization/budget-categories']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><i class="fa fa-usd"></i>
                    <span> Fiscal Budget</span>
                  </a>
                </li>
                <!-- <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="organization.editBudgetCategory"
                >
                  <a
                    [routerLink]="['/organization/budget-categories-2']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><i class="fa fa-usd"></i>
                    <span> Fiscal Budget 2</span>
                  </a>
                </li> -->
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="transaction.viewAccount"
                >
                  <a
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="['/payments/ach-payments']"
                    routerLinkActive="active"
                    ><i class="fas fa-money"></i>
                    <span>Payments</span>
                  </a>
                </li>
              </ul>
            </li>

            <li
              [ngClass]="{ active: currentActiveMenu == 'groups' }"
              [allowedPermissions]="['user.viewMember', 'user.manage']"
              menuPermission
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('groups')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'groups'" (keydown)="onMenuToggleKeydown($event, 'groups')"
                ><i class="fa fa-users"></i> <span>Groups</span></a
              >
              <ul *ngIf="currentActiveMenu == 'groups'">
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu == 'member' }"
                  menuPermission
                  requiredPermission="user.viewMember"
                >
                  <a
                    [routerLink]="['/members/member/list']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    ><i class="fa fa-users"></i>
                    <span>Members</span>
                  </a>
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{
                    active: currentActiveMenu == 'vendor'
                  }"
                  menuPermission
                  requiredPermission="user.viewMember"
                >
                  <a
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [routerLink]="['/members/vendor/list']"
                    ><i class="fa fa-users"></i> <span>Vendors</span>
                  </a>
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="user.manage"
                >
                  <a [routerLink]="['/sub-groups']"
                    ><i class="fa fa-list"></i> <span>Sub-Groups</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu === 'sub-group-roles' }"
                  menuPermission
                  requiredPermission="organization.manageSubGroupRoles"
                >
                  <a
                    (click)="activeInactiveMenu('sub-group-roles')"
                    [routerLink]="['/organization/sub-group-roles']"
                    ><i class="fa fa-id-badge"></i> <span>Sub-Group Roles</span></a
                  >
                </li>
                <li
                  class=""
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [ngClass]="{ active: currentActiveMenu === 'sub-group-types' }"
                  menuPermission
                  requiredPermission="organization.manageSubGroupTypes"
                >
                  <a
                    (click)="activeInactiveMenu('sub-group-types')"
                    [routerLink]="['/organization/sub-group-types']"
                    ><i class="fa fa-list-alt"></i> <span>Sub-Group Types</span></a
                  >
                </li>
              </ul>
            </li>

            <!-- PDF Utilities — Administrators only -->
            <li
              [ngClass]="{ active: currentActiveMenu == 'pdf-utilities' }"
              menuPermission
              [allowedPermissions]="['organization.editOrganizationProfile']"
            >
              <a class="has-arrow sidebar-toggle" (click)="activeInactiveMenu('pdf-utilities')" role="button" tabindex="0" [attr.aria-expanded]="currentActiveMenu == 'pdf-utilities'" (keydown)="onMenuToggleKeydown($event, 'pdf-utilities')"
                ><i class="fa fa-file-pdf-o"></i> <span>PDF Utilities</span></a>
              <ul *ngIf="currentActiveMenu == 'pdf-utilities'">
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/utilities', 'pdf-tools', 'compress']"><i class="fa fa-compress"></i> <span>Compress</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/utilities', 'pdf-tools', 'merge']"><i class="fa fa-files-o"></i> <span>Merge</span></a>
                </li>
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/utilities', 'pdf-tools', 'split']"><i class="fa fa-scissors"></i> <span>Split</span></a>
                </li>
              </ul>
            </li>

            <li class="campaigns-section" [class.active]="isCampaignListExpanded">
              <button
                type="button"
                class="campaigns-toggle has-arrow sidebar-toggle"
                [attr.aria-expanded]="isCampaignListExpanded"
                aria-controls="current-sale-campaigns"
                (click)="toggleCampaignList()"
                (keydown)="onCampaignListKeydown($event)"
              >
                <span class="campaigns-toggle-left">
                  <i class="fas fa-wallet"></i>
                  <span>Current Sale Campaigns</span>
                </span>
              </button>

              <div
                id="current-sale-campaigns"
                class="campaigns-panel"
                [class.is-expanded]="isCampaignListExpanded"
                [attr.aria-hidden]="!isCampaignListExpanded"
              >
                <ul class="campaign-list">
                  <li *ngFor="let cam of activeCampaigns" [class.selected]="isCampaignSelected(cam)">
                    <a
                      [title]="cam.title"
                      target="_blank"
                      rel="noopener noreferrer"
                      [href]="displayCampaignUrl(cam)"
                      (click)="selectCampaign(cam)"
                    >
                      <i class="fa" [ngClass]="isCampaignSelected(cam) ? 'fa-star' : 'fa-star-o'"></i>
                      <span>{{ cam.title }}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <div
        class="tab-pane p-l-15 p-r-15"
        id="Reports"
        [ngClass]="{ active: navTab == 'reports' }"
        menuPermission
        [allowedPermissions]="[
          'report.viewTreasurer',
          'report.viewByCategory',
          'report.viewAccount',
          'report.viewBudgetItem'
        ]"
      >
        <nav id="left-sidebar-nav" class="sidebar-nav">
          <ul id="main-menu" class="metismenu">
            <li
              [ngClass]="{ active: currentActiveMenu == 'treasurer-report' }"
              [allowedPermissions]="['report.viewTreasurer']"
              menuPermission
            >
              <a
                class="has-arrow sidebar-toggle"
                (click)="activeInactiveMenu('treasurer-report')"
                role="button"
                tabindex="0"
                [attr.aria-expanded]="currentActiveMenu == 'treasurer-report'"
                (keydown)="onMenuToggleKeydown($event, 'treasurer-report')"
                ><i class="fa fa-shopping-cart"></i>
                <span>Treasurer Reports</span></a
              >
              <ul *ngIf="currentActiveMenu == 'treasurer-report'">
                <li
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="report.viewTreasurer"
                >
                  <a [routerLink]="['/reports/treasurer']"
                    ><i class="fas fa-treasure-chest" aria-hidden="true"></i
                    >Monthly Detail</a
                  >
                </li>
                <li
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="report.viewTreasurer"
                >
                  <a [routerLink]="['/reports/treasurer-budget-summary']"
                    ><i class="fas fa-treasure-chest" aria-hidden="true"></i
                    >Monthly Summary</a
                  >
                </li>
                <li
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  menuPermission
                  requiredPermission="report.viewTreasurer"
                >
                  <a [routerLink]="['/reports/treasurer-budget-annual']"
                    ><i class="fas fa-treasure-chest" aria-hidden="true"></i
                    >Annual Budget Report</a
                  >
                </li>
                     <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                  <a [routerLink]="['/naa-budget', 'reports']"><i class="fa fa-bar-chart"></i> <span>Reports</span></a>
                </li>
              </ul>
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewTreasurer"
            >
              <a [routerLink]="['/reports/treasurer-category']"
                ><i class="fa fa-usd" aria-hidden="true"></i>Monthly Category
                Report</a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewByCategory"
            >
              <a
                [routerLink]="['/reports/by-category']"
                style="white-space: nowrap"
                ><i class="fa fa-th" aria-hidden="true"></i>Category
                Transactions</a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewBudgetItem"
            >
              <a
                [routerLink]="['/reports/budget-item']"
                style="white-space: nowrap"
                ><i class="fa fa-th" aria-hidden="true"></i>Budget Item
                Transactions</a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewByCategory"
            >
              <a
                [routerLink]="['/reports/by-account']"
                style="white-space: nowrap"
                ><i class="fas fa-sack-dollar" aria-hidden="true"></i>Account
                Transactions</a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewAccount"
            >
              <a [routerLink]="['/reports/member-transactions']"
                ><i class="fa fa-user" aria-hidden="true"></i>Member
                Transactions</a
              >
            </li>
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewBudgetItem"
            >
              <a
                [routerLink]="['/reports/variance']"
                style="white-space: nowrap"
                ><i class="fa fa-th" aria-hidden="true"></i>Budget Report</a
              >
            </li>

            <!-- <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              menuPermission
              requiredPermission="report.viewBudgetItem"
            >
              <a
                [routerLink]="['/reports/donation']"
                style="white-space: nowrap"
                ><i class="fa fa-th" aria-hidden="true"></i>Donation Report</a
              >
            </li> -->
            <!-- </ul> -->
          </ul>
        </nav>
      </div>
      <div
        class="tab-pane p-l-15 p-r-15"
        id="setting"
        [ngClass]="{ active: navTab == 'setting' }"
      >
        <nav id="left-sidebar-nav" class="sidebar-nav">
          <ul id="main-menu" class="metismenu">
            <li
              [ngClass]="{
                active: currentActiveMenu === 'organization-profile'
              }"
              menuPermission
              requiredPermission="organization.editOrganizationProfile"
            >
              <a
                (click)="activeInactiveMenu('organization-profile')"
                [routerLink]="['/organization/profile']"
                ><i class="icon-briefcase"></i>
                <span>Organization Profile</span>
              </a>
            </li>
            <li
              [ngClass]="{ active: currentActiveMenu === 'organization-subscriptions' }"
              menuPermission
              requiredPermission="organization.editOrganizationProfile"
            >
              <a
                (click)="activeInactiveMenu('organization-subscriptions')"
                [routerLink]="['/organization', organizationId, 'subscriptions']"
                ><i class="fa fa-credit-card"></i>
                <span>Subscriptions</span>
              </a>
            </li>
            <li
              [ngClass]="{ active: currentActiveMenu === 'custom-fields' }"
              menuPermission
              requiredPermission="organization.editCustomField"
            >
              <a
                (click)="activeInactiveMenu('custom-fields')"
                [routerLink]="['/organization/custom-fields']"
                ><i class="fa fa-list-ul"></i>
                <span>Custom Fields</span>
              </a>
            </li>
          </ul>
        </nav>
        <hr />
        <h6>Choose Mode</h6>
        <ul class="choose-skin list-unstyled">
          <li
            data-theme="white"
            [ngClass]="{ active: darkClass == '' }"
            (click)="changeDarkMode('')"
          >
            <div class="white"></div>
            <span>Light</span>
          </li>
          <li
            data-theme="black"
            [ngClass]="{ active: darkClass == 'full-dark' }"
            (click)="changeDarkMode('full-dark')"
          >
            <div class="black"></div>
            <span>Dark</span>
          </li>
        </ul>
        <hr />
        <h6>Communication Settings</h6>
        <ul class="setting-list list-unstyled">
          <li>
            <label class="fancy-checkbox">
              <input
                type="checkbox"
                name="checkbox"
                [(ngModel)]="sendEmail"
                (click)="
                  updatePreference('communication.email', $event.target.checked)
                "
              />
              <span>Email Notification</span>
            </label>
          </li>
          <li>
            <label class="fancy-checkbox">
              <input
                type="checkbox"
                name="checkbox"
                [(ngModel)]="sendSms"
                (click)="
                  updatePreference('communication.sms', $event.target.checked)
                "
              />
              <span>SMS/Text Notifications</span>
            </label>
          </li>
        </ul>
      </div>
      <div
        class="tab-pane p-l-15 p-r-15"
        id="question"
        [ngClass]="{ active: navTab == 'question' }"
      >
        <form>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="icon-magnifier"></i
              ></span>
            </div>
            <input type="text" class="form-control" placeholder="Search..." />
          </div>
        </form>
        <ul class="list-unstyled question">
          <li class="menu-heading">HOW-TO</li>
          <li class="menu-heading">ACCOUNT</li>
          <li><a href="javascript:void(0);">Change Password? (TODO)</a></li>
          <li class="menu-heading">BILLING</li>
          <li><a href="javascript:void(0);">Payment info (TODO)</a></li>
          <li><a href="javascript:void(0);">Auto-Renewal (TODO)</a></li>
          <li class="menu-button m-t-30">
            <a href="javascript:void(0);" class="btn btn-primary"
              ><i class="icon-question"></i> Need Help?</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
